export default __webpack_public_path__ + "static/media/Remember-min.1d40bb2b.webp";